import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { DASHBOARD_ICONS } from "../../../Helpers/ICONS";
import { PROCESSOR_ROUTES } from "../../../app/router/routes";
import NavBar from "../../../components/navbar/NavBar";
import { SectionColumn } from "../../../layouts/sections";

import { getStepStatusByApplicationId } from "../../../app/api/NOCU/applicationAPI";
import { getStakeholderApplicationNumber } from "../../../app/api/NOCU/helpers/applicationApiHelpers";
import LoaderComponent from "../../../components/Loader/LoaderComponent";
import { createStepper } from "../../../components/stepper/dynamicStepper";
import { convertStepperRes } from "./dataManipulation";
import ProcessorStep1 from "./flow/ProcessorStep1";
import ProcessorStep2 from "./flow/ProcessorStep2";
import ProcessorStep3 from "./flow/ProcessorStep3";
import ProcessorStep4 from "./flow/ProcessorStep4";
import ProcessorStep5 from "./flow/ProcessorStep5";
import ProcessorStep6 from "./flow/ProcessorStep6";
import ProcessorStep7 from "./flow/ProcessorStep7";
import { getApplicationStatusOnSession } from "../../certificationBody/dataManipulation";

export const stepperName = "PROCESSOR";

const ProcessorReviewHome = () => {
	const [res, setRes] = useState();
	const [stepper, setStepper] = useState();
	const [stepperData, setStepperData] = useState();
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		getStepStatusByApplicationId(getStakeholderApplicationNumber())
			.then((res) => {
				setRes(res.data);
				console.log("Data", res.data);
				console.log("Stepper=====>", convertStepperRes(res.data));
				setStepper(convertStepperRes(res.data));
			})
			.catch((e) => console.log(e));
	}, []);

	useEffect(() => {
		stepper && setStepperData(createStepper(stepperName, stepper));
	}, [stepper]);

	const routeArray = [
		PROCESSOR_ROUTES.STEP01,
		PROCESSOR_ROUTES.STEP02,
		PROCESSOR_ROUTES.STEP03,
		PROCESSOR_ROUTES.STEP04,
		PROCESSOR_ROUTES.STEP05,
		PROCESSOR_ROUTES.STEP06,
		PROCESSOR_ROUTES.STEP07,
	];
	return (
		<div>
			<LoaderComponent isOpen={isLoading} />
			<NavBar
				stepperName={stepperName}
				title={"Processor"}
				tableIcon={DASHBOARD_ICONS.processor}
				tableURL={PROCESSOR_ROUTES.HOME}
			/>

			{res && stepperData && (
				<SectionColumn className='w-full pt-1'>
					<Route path={PROCESSOR_ROUTES.STEP01}>
						<ProcessorStep1
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							readOnly={
								getApplicationStatusOnSession()
									? false
									: res[0]?.reviewStatus === "APPROVED" || res[0]?.reviewStatus === "RESUBMIT"
									? true
									: false
							}
						/>
					</Route>
					<Route path={PROCESSOR_ROUTES.STEP02}>
						<ProcessorStep2
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							readOnly={
								getApplicationStatusOnSession()
									? false
									: res[1]?.reviewStatus === "APPROVED" || res[1]?.reviewStatus === "RESUBMIT"
									? true
									: false
							}
						/>
					</Route>
					<Route path={PROCESSOR_ROUTES.STEP03}>
						<ProcessorStep3
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							readOnly={
								getApplicationStatusOnSession()
									? false
									: res[2]?.reviewStatus === "APPROVED" || res[2]?.reviewStatus === "RESUBMIT"
									? true
									: false
							}
						/>
					</Route>
					<Route path={PROCESSOR_ROUTES.STEP04}>
						<ProcessorStep4
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							readOnly={
								getApplicationStatusOnSession()
									? false
									: res[5]?.reviewStatus === "APPROVED" || res[5]?.reviewStatus === "RESUBMIT"
									? true
									: false
							}
						/>
					</Route>
					<Route path={PROCESSOR_ROUTES.STEP05}>
						<ProcessorStep5
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							readOnly={
								getApplicationStatusOnSession()
									? false
									: res[7]?.reviewStatus === "APPROVED" || res[7]?.reviewStatus === "RESUBMIT"
									? true
									: false
							}
						/>
					</Route>
					<Route path={PROCESSOR_ROUTES.STEP06}>
						<ProcessorStep6
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							readOnly={
								getApplicationStatusOnSession()
									? false
									: res[3]?.reviewStatus === "APPROVED" || res[3]?.reviewStatus === "RESUBMIT"
									? true
									: false
							}
						/>
					</Route>
					<Route path={PROCESSOR_ROUTES.STEP07}>
						<ProcessorStep7
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							readOnly={
								getApplicationStatusOnSession()
									? false
									: res[4]?.reviewStatus === "APPROVED" || res[4]?.reviewStatus === "RESUBMIT"
									? true
									: false
							}
						/>
					</Route>
				</SectionColumn>
			)}
		</div>
	);
};

export default ProcessorReviewHome;
